/*
 * cl-papercut-overlays.js  (overlays paper cuts, 2026-10-05)
 * Loaded by snippets/cl-papercut-overlays.liquid (rendered from snippets/sticky-atc.liquid).
 * Changes behaviour only; no new design. Each block is independent and fails silently.
 */
(function () {
  'use strict';
  if (window.__clPapercutOverlays) return;
  window.__clPapercutOverlays = true;

  /* ------------------------------------------------------------------
   * 1. Keep the Shopify Inbox "Live chat" bubble off tappable CTAs.
   *    The bubble (<shopify-chat>, z-index 2147483000) sat on top of the
   *    mobile sticky Add to Cart button (taps opened chat), hero buttons
   *    and the HulkApps quantity table. We lift it (Shopify's own
   *    --shopify-chat-activator-offset property, set inline because the
   *    component registers the property after page CSS computes) just
   *    enough to clear whatever CTA is under it, and drop it back when
   *    nothing is. Never moves while the chat panel is open.
   * ------------------------------------------------------------------ */
  (function chatKeepClear() {
    /* Current name, plus the pre-2026 name in case an older build loads. */
    var VARS = ['--shopify-chat-activator-offset', '--shopify-agent-activator-offset'];
    var GAP = 8;
    /* Things the bubble must not sit on. Seeing one of these under it is what triggers a lift. */
    var PRIMARY = [
      '.hulkapps-volumes table',
      'form[action*="/cart/add"] [type="submit"]',
      '[name="checkout"]',
      'a.btn', 'a.button', 'button.btn', 'button.button', '.gf_button',
      'button[class*="gp-button"]', 'a[class*="gp-button"]'
    ].join(',');
    /* Anything else tappable: the bubble may not be lifted ONTO these either (e.g. colour swatches). */
    var SECONDARY = 'a[href],button,input:not([type="hidden"]),select,textarea,label,[role="button"],.gf_swatch,[class*="swatch"]';
    var chat = null;
    var base = null;   /* activator's unlifted distance from the viewport bottom (px) */
    var lift = 0;      /* extra px we currently add */
    var raf = 0;
    var prim = [];
    var sec = [];
    var cacheAt = 0;

    function activator() {
      if (!chat || !chat.isConnected) chat = document.querySelector('shopify-chat');
      if (!chat || !chat.shadowRoot) return null;
      return chat.shadowRoot.querySelector('button.activator, [part~="activator"]');
    }

    function refresh() {
      var now = Date.now();
      if (cacheAt && now - cacheAt < 1500) return;
      cacheAt = now;
      prim = [];
      var found = document.querySelectorAll(PRIMARY);
      for (var j = 0; j < found.length; j++) {
        /* quantity table: keep its "QUANTITY DISCOUNTS" heading clear too */
        var el = found[j].closest('.hulkapps-volumes') ? (found[j].closest('.gf_row') || found[j]) : found[j];
        if (prim.indexOf(el) < 0 && getComputedStyle(el).visibility !== 'hidden') prim.push(el);
      }
      sec = [];
      var all = document.querySelectorAll(SECONDARY);
      for (var k = 0; k < all.length; k++) {
        /* skip closed menus etc. (visibility:hidden still has a box) */
        if (all[k].getClientRects().length && getComputedStyle(all[k]).visibility !== 'hidden') sec.push(all[k]);
      }
    }

    /* rects of visible elements in the bubble's column */
    function rects(list, left, right, vh) {
      var out = [];
      for (var i = 0; i < list.length; i++) {
        var r = list[i].getBoundingClientRect();
        if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < vh && r.left < right && r.right > left) out.push(r);
      }
      return out;
    }

    function firstHit(list, t, b) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].top < b && list[i].bottom > t) return list[i];
      }
      return null;
    }

    function apply(px) {
      if (px === lift) return;
      lift = px;
      for (var i = 0; i < VARS.length; i++) {
        if (px > 0) chat.style.setProperty(VARS[i], (base + px) + 'px');
        else chat.style.removeProperty(VARS[i]);
      }
    }

    function compute() {
      raf = 0;
      var a = activator();
      if (!a || chat.hasAttribute('open')) return;
      var ar = a.getBoundingClientRect();
      if (!ar.width || !ar.height) return;
      var vh = window.innerHeight;
      /* re-measure whenever we are not lifting: page CSS (e.g. the spec-pro
         template's own sticky-bar rule) may change the default position */
      if (!lift) base = Math.max(0, Math.round(vh - ar.bottom));
      else if (base === null) return;
      /* where the bubble sits with no lift */
      var top0 = ar.top + lift;
      var bottom0 = ar.bottom + lift;
      var left = ar.left - GAP;
      var right = ar.right + GAP;
      refresh();
      /* the sticky bar is looked up live (it toggles), the rest comes from the cache */
      /* theme sticky bar, or the spec-pro pilot template's own bar (.cls-sticky.is-on) */
      var bars = document.querySelectorAll('#cl-sticky-atc.cl-visible, .cls-sticky.is-on');
      var bar = null;
      for (var b = 0; b < bars.length && !bar; b++) if (bars[b].getBoundingClientRect().height) bar = bars[b]; /* skip ones hidden by CSS */
      var p = rects(bar ? prim.concat([bar]) : prim, left, right, vh);
      if (!firstHit(p, top0 - GAP, bottom0 + GAP)) { apply(0); return; }
      var all = p.concat(rects(sec, left, right, vh));
      var cap = Math.min(vh * 0.45, 240); /* never float the bubble far up the screen */
      var need = 0;
      var hit;
      for (var k = 0; k < 12 && need <= cap; k++) {
        hit = firstHit(all, top0 - need - GAP, bottom0 - need + GAP);
        if (!hit) break;
        need = bottom0 - hit.top + GAP;
      }
      if (hit || need > cap) {
        /* No clean spot nearby: stay put, except always clear the sticky Add to Cart
           bar (the page's main CTA wins over whatever sits just above it). */
        need = 0;
        if (bar) {
          var br = bar.getBoundingClientRect();
          if (br.top < bottom0 + GAP) need = Math.min(bottom0 - br.top + GAP, vh * 0.45);
        }
      }
      apply(Math.max(0, Math.round(need)));
    }

    function schedule() {
      if (!raf) raf = window.requestAnimationFrame(compute);
    }

    var tries = 0;
    (function wait() {
      if (activator()) {
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', function () { if (!lift) base = null; schedule(); });
        document.addEventListener('cl:sticky-atc', function () { cacheAt = 0; schedule(); });
        setInterval(function () { if (!document.hidden) schedule(); }, 1000);
        schedule();
      } else if (tries++ < 60) {
        setTimeout(wait, 500);
      }
    })();
  })();
  /* ------------------------------------------------------------------
   * 3. Show the HulkApps quantity-discount table on phones.
   *    GemPages product templates have separate desktop and mobile
   *    copies of the buy box; the table (and its "QUANTITY DISCOUNTS"
   *    heading row) exists only in the desktop copy, which is
   *    display:none on phones. We MOVE that same row (not a copy, so
   *    HulkApps and the volume-pricing script keep updating the one
   *    table) into the matching column of the visible mobile buy box,
   *    i.e. the column next to price / quantity / Add to Cart, exactly
   *    where desktop shows it. Moved back if the desktop layout returns.
   * ------------------------------------------------------------------ */
  (function volumeTableOnMobile() {
    function shown(el) { return !!(el && el.getClientRects().length); }

    function place() {
      var vols = document.querySelectorAll('.hulkapps-volumes');
      for (var i = 0; i < vols.length; i++) {
        var vol = vols[i];
        var row = vol.closest('.gf_row');
        if (!row || row.querySelector('.gf_product-prices')) continue;
        var col = row.parentElement && row.parentElement.closest('.gf_column');
        if (!col || !col.id) continue;
        if (!row.__clHome) {
          row.__clHome = document.createComment('cl-papercut: volume table home');
          row.parentNode.insertBefore(row.__clHome, row);
        }
        if (shown(row)) continue;
        var home = row.__clHome;
        if (shown(home.parentElement) && home.parentElement !== row.parentElement) {
          home.parentNode.insertBefore(row, home.nextSibling);   /* desktop again: put it back */
          continue;
        }
        /* visible price (or Add to Cart) in the same product form -> its row ->
           the sibling column carrying the same GemPages id as the table's column */
        var ANCH = '.gf_product-prices, [type="submit"], button[name="add"]';
        var form = vol.closest('form');
        /* same form first; some templates put the mobile buy box in its own product form */
        var anchors = Array.prototype.slice.call((form || document).querySelectorAll(ANCH))
          .concat(Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"] .gf_product-prices, form[action*="/cart/add"] [type="submit"]')));
        for (var j = 0; j < anchors.length; j++) {
          if (!shown(anchors[j]) || anchors[j].closest('#cl-sticky-atc')) continue;
          var anchorRow = anchors[j].closest('.gf_row');
          var slot = null;
          for (var c = anchorRow ? anchorRow.firstElementChild : null; c; c = c.nextElementSibling) {
            if (c.id === col.id && c.classList.contains('gf_column') && shown(c)) { slot = c; break; }
          }
          if (slot) { slot.insertBefore(row, slot.firstChild); break; }
        }
      }
    }

    function run() { try { place(); } catch (e) { /* never break the page */ } }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    window.addEventListener('load', run);
    setTimeout(run, 2500); /* GemPages finishes laying out late */
    var mq = window.matchMedia('(max-width: 767px)');
    if (mq.addEventListener) mq.addEventListener('change', run);
    else if (mq.addListener) mq.addListener(run);
  })();
  /* ------------------------------------------------------------------
   * 4. Accessibility names + stray "&nbsp;" text. No visual change:
   *    only aria-label / alt attributes are added, and Seal
   *    Subscriptions' purchase-options label, which prints the literal
   *    text "&nbsp;", gets a real non-breaking space (same height).
   *    GemPages/app markup is regenerated on publish, so this runs at
   *    runtime instead of editing 60+ generated templates.
   * ------------------------------------------------------------------ */
  (function a11yNames() {
    function clean(v) { return (v || '').replace(/\s+/g, ' ').trim(); }   /* \s includes &nbsp; */

    function hasName(el) {
      if (clean(el.getAttribute('aria-label')) || el.getAttribute('aria-labelledby') || clean(el.getAttribute('title'))) return true;
      if (clean(el.textContent)) return true;
      var imgs = el.querySelectorAll('img[alt]');
      for (var i = 0; i < imgs.length; i++) if (clean(imgs[i].getAttribute('alt'))) return true;
      return false;
    }

    function label(el, text) {
      text = clean(text).slice(0, 100);
      if (text) el.setAttribute('aria-label', text);
    }

    function fileName(img) {
      var src = (img && (img.getAttribute('src') || img.getAttribute('data-src'))) || '';
      return (src.split('?')[0].split('/').pop() || '').replace(/\.\w+$/, '');
    }

    /* "number-1-4.png" -> 1/4", "number-1-1-4" -> 1 1/4", "number-1-102" (sic) -> 1 1/2" */
    var SIZES = { '1-4': '1/4', '1-2': '1/2', '3-4': '3/4', '1-1-4': '1 1/4', '1-1-2': '1 1/2', '1-102': '1 1/2' };
    function sizeName(img, href) {
      var m = /^number-([\d-]+)$/.exec(fileName(img));
      if (!m) return '';
      var size = SIZES[m[1]] || (/^\d+$/.test(m[1]) ? m[1] : '');
      if (!size) return '';
      return size + '"' + (/dot/i.test(href) ? ' dot stickers' : '');
    }

    function fromHref(href) {
      var path = (href || '').split('#')[0].split('?')[0].replace(/\/+$/, '');
      var last = path.split('/').pop() || '';
      try { last = decodeURIComponent(last); } catch (e) { /* keep raw */ }
      return last.replace(/[-_]+/g, ' ');
    }

    var NETS = { facebook: 'Facebook', instagram: 'Instagram', twitter: 'Twitter', x: 'X', linkedin: 'LinkedIn', youtube: 'YouTube', pinterest: 'Pinterest', tiktok: 'TikTok' };

    function nameLinks() {
      var links = document.querySelectorAll('a[href]');
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        if (hasName(a)) continue;
        var href = a.getAttribute('href') || '';
        var tip = a.parentElement && a.parentElement.querySelector(':scope > .tooltip-text');
        var img = a.querySelector('img');
        if (tip && clean(tip.textContent)) { label(a, tip.textContent); continue; }
        if (a.classList.contains('hero-link')) {
          /* GemPages hero banner: the whole tile is the link; name it after the tile's own text */
          var mod = a.closest('.module');
          var parts = mod ? mod.querySelectorAll('h1,h2,h3,h4,h5,h6,.text-edit,p') : [];
          var text = '';
          for (var k = 0; k < parts.length && !text; k++) text = clean(parts[k].textContent);
          if (text) { label(a, text); continue; }
        }
        if (img) {
          var sz = sizeName(img, href);
          if (sz) { label(a, sz); continue; }
          if (clean(img.getAttribute('title'))) { label(a, img.getAttribute('title')); continue; }
          if (/GoldenGuarantee/i.test(img.getAttribute('src') || '')) {
            if (!img.hasAttribute('alt')) img.setAttribute('alt', 'Golden Guarantee: no questions asked returns');
            continue;
          }
        }
        var social = /^https?:\/\/(?:www\.)?(facebook|instagram|twitter|x|linkedin|youtube|pinterest|tiktok)\.com\//i.exec(href);
        if (social) { label(a, 'ChromaLabel on ' + (NETS[social[1].toLowerCase()] || social[1])); continue; }
        if (/^tel:/i.test(href)) { label(a, 'Call ' + href.slice(4).replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3')); continue; }
        if (/^mailto:/i.test(href)) { label(a, 'Email ' + href.slice(7).split('?')[0]); continue; }
        if (href.charAt(0) !== '#') label(a, fromHref(href));
      }
    }

    function nameButtons() {
      var dots = document.querySelectorAll('.owl-dots');
      for (var d = 0; d < dots.length; d++) {
        var bs = dots[d].querySelectorAll('.owl-dot');
        for (var i = 0; i < bs.length; i++) if (!hasName(bs[i])) bs[i].setAttribute('aria-label', 'Go to slide ' + (i + 1));
      }
      /* GemPages accordion +/- icons: name them after their question */
      var acc = document.querySelectorAll('button.wrapp-icon');
      for (var a = 0; a < acc.length; a++) {
        var q = acc[a].parentElement && acc[a].parentElement.querySelector('.text-edit');
        if (q && !hasName(acc[a])) label(acc[a], q.textContent);
      }
      var adds = document.querySelectorAll('form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] button[type="submit"]');
      for (var j = 0; j < adds.length; j++) if (!hasName(adds[j])) adds[j].setAttribute('aria-label', 'Add to cart');
    }

    function nameInputs() {
      var qs = document.querySelectorAll('input.gf_pq_qty, input[name="quantity"]:not([type="hidden"]), input[name^="quantity-"]:not([type="hidden"])');
      for (var i = 0; i < qs.length; i++) {
        var q = qs[i];
        if ((q.labels && q.labels.length) || q.getAttribute('aria-label') || q.getAttribute('aria-labelledby')) continue;
        q.setAttribute('aria-label', 'Quantity');
      }
      /* GemPages contact forms: fields with no label and no placeholder -> name from contact[field] */
      var fs = document.querySelectorAll('form input[name^="contact["]:not([type="hidden"]):not([type="submit"]), form textarea[name^="contact["]');
      for (var j = 0; j < fs.length; j++) {
        var f = fs[j];
        if ((f.labels && f.labels.length) || f.getAttribute('aria-label') || f.getAttribute('aria-labelledby') || clean(f.getAttribute('placeholder'))) continue;
        var m = /\[([^\]]+)\]$/.exec(f.getAttribute('name') || '');
        if (m) label(f, m[1].replace(/[-_]+/g, ' ').replace(/^\w/, function (c) { return c.toUpperCase(); }));
      }
    }

    function altText() {
      var imgs = document.querySelectorAll('img:not([alt])');
      var title = '';
      var og = document.querySelector('meta[property="og:title"]');
      if (og) title = og.getAttribute('content') || '';
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        if (img.classList.contains('gf_youtube-thumb')) img.setAttribute('alt', 'Play video');
        else if (/(^|\s)gp_lazy(bg|forbg|bg_tl|bg_mb)/.test(img.className)) img.setAttribute('alt', '');   /* decorative backgrounds */
        else if (img.classList.contains('metafield-file_reference') && title) img.setAttribute('alt', title);
      }
    }

    /* GemPages hero overlay: aria-label on a role-less, purely decorative div (aria-prohibited-attr) */
    function overlays() {
      var ds = document.querySelectorAll('div[aria-label="Overlay"]:not([role])');
      for (var i = 0; i < ds.length; i++) ds[i].removeAttribute('aria-label');
    }

    function sealNbsp() {
      var ls = document.querySelectorAll('.sls-purchase-options-label');
      for (var i = 0; i < ls.length; i++) {
        if (ls[i].textContent.trim() === '&nbsp;') ls[i].textContent = ' ';
      }
    }

    function run() {
      var steps = [nameLinks, nameButtons, nameInputs, altText, overlays, sealNbsp];
      for (var i = 0; i < steps.length; i++) { try { steps[i](); } catch (e) { /* never break the page */ } }
    }

    var t = 0;
    function later() { clearTimeout(t); t = setTimeout(run, 800); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    window.addEventListener('load', run);
    setTimeout(run, 2500);
    setTimeout(run, 6000);
    window.addEventListener('resize', later);
    document.addEventListener('change', later, true);   /* variant changes re-render app widgets */
    document.addEventListener('click', later, true);
  })();
})();
